import React, { useState, useEffect, useRef } from "react";
import UploadIcon from "../../assets/img/upload-icon-blue.svg";
import DeletePopup from "../Common/DeletePopup";
import {
  uploadFileViaMultipart,
  removeFile,
} from "../../Actions/uploadFileActions";
import { useDispatch } from "react-redux";
import CustomPopUpScotland from "../Common/customPopUpScotland";

function SCOTSingleFileUpload({
  name,
  id,
  title,
  record,
  placeholder,
  fieldId,
  isRequired,
  getCount,
  totalCount,
  getUpdatedScotlandData,
  isMandatory,
  errId,
  hasError = false,
}) {
  const dispatch = useDispatch();
  const [fileLength, setFileLength] = useState();
  const [showModal, setShowModal] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(0);
  const [isFileUploaded, setIsfileUploaded] = useState(false);
  const [isFileUploadError, setIsfileUploadError] = useState(false);
  const reRender = () => {
    getUpdatedScotlandData();
  };

  const uploadFile = async (event) => {
    const chosenFiles = event.target.files;
    if(chosenFiles.length > 0) {
      const maxFileSize = 5242880/1024;
      for (var i = 0; i < chosenFiles.length; i++) {
        console.log('File size - ',chosenFiles[i].size/1024/1024);
        if(chosenFiles[i].size > 5242880){
          alert("File cannot be larger than 5MB");
          setIsfileUploadError(true);
          event.target.value = null;
          return false;
        }
        if (
          chosenFiles[i].name.split(".").pop() == "docx" ||
          chosenFiles[i].name.split(".").pop() == "DOCX"
        ) {
          //flow will continue
        } else {
          alert("Invalid file format");
          setIsfileUploadError(true);
          event.target.value = null;
          return false;
        }
      }
      await dispatch(
        uploadFileViaMultipart("check_documents", chosenFiles, record)
      );
      getUpdatedScotlandData();
      setDocumentUploaded();
    }
  };

  const closeModal = () => {
    getUpdatedScotlandData();
    setShowModal(0);
  };

  const openModal = () => {
    setShowModal(1);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(0);
  };

  const deleteHandler = () => {
    setShowDeleteModal(1);
  };

  const proceedDelete = async () => {
    const recordArray = {};
    recordArray.doc_chk = record.caseCheckId;
    recordArray.doc_ids = record.docId;
    recordArray.doc_ref = "all";
    await dispatch(removeFile("check_documents", recordArray));
    setShowDeleteModal(0);
    getUpdatedScotlandData();
    setDocumentUploaded();
  };

  const setDocumentUploaded = () => {
    setIsfileUploaded(!isFileUploaded);
  };
  return (
    <>
      <div className="row mt-3">
        <div className="col-sm-4 col-md-12 col-xl-4">
          <h6 className="">
            {title}
            {isMandatory == true && <sup className="text-danger">*</sup>}
          </h6>
          <label htmlFor={id} className="upload-box mb-0 flex-column pt-1 pb-1">
            <img src={UploadIcon} className="mb-1" alt="" />
            <label class="mb-0 text-center" style={{ lineHeight: "16px" }}>
              <div className="right text-right w-100">
                <div className="position-relative">
                  <input
                    id={id}
                    type="file"
                    style={{ opacity: "0", width: "100%" }}
                    // accept="image/*"
                    multiple
                    onChange={(e) => uploadFile(e)}
                    onClick={(event) => {
                      event.target.value = null;
                    }}
                    title="Choose Files"
                  ></input>
                </div>
              </div>
              <small class="text-center fnt-smi-bld">
                <span className="text-primary">Click to upload</span>{" "}
                <span className="text-muted">
                  {/* or drag and drop */}
                  <br />
                  DOCX format is supported
                  <br />
                  Max File size: 5MB
                </span>
              </small>
            </label>
          </label>
          {hasError === true && (
            <p className="err text-danger" id={errId}>
              This field is required
            </p>
          )}
        </div>

        {totalCount > 0 && (
          <div
            className={"col-sm-4 col-md-12 col-xl-4"}
            id={`doc_${record.docId}`}
          >
            <>
              <h6>&nbsp;</h6>
              <div className="after-upload-box w-100">
                {totalCount > 0 && (
                  <div>
                    <i class="far fa-file mr-3"></i>
                    <small className="fnt-smi-bld">
                      {totalCount} files uploaded
                    </small>
                  </div>
                )}{" "}
                <div>
                  {/* <a href="" download> */}
                    <i
                    class="fas fa-eye text-muted mr-3 cursor-pointer"
                    onClick={openModal}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="View"
                  ></i>
                  {/* </a> */}
                  <i
                    class="fas fa-trash-alt text-muted text-danger cursor-pointer"
                    onClick={deleteHandler}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Delete"
                  ></i>
                </div>
              </div>
            </>

          </div>
        )}
      </div>
      {showDeleteModal === 1 && (
        <DeletePopup
          showModalBox={showDeleteModal}
          closePopup={closeDeleteModal}
          title="Delete Uploaded Files"
          description="Are you sure you want to delete all the uploaded files? This action cannot be undone."
          proceedHandler={proceedDelete}
        />
      )}

      {showModal === 1 && (
        <CustomPopUpScotland
          showModalBox={showModal}
          closePopup={closeModal}
          record={record}
          title={title}
          reRenderAgain={reRender}
        />
      )}
    </>
  );
}

export default SCOTSingleFileUpload;
